/* eslint-disable react-hooks/exhaustive-deps */
import {useFormik} from 'formik'
import React, {FC, useEffect, useMemo, useState} from 'react'
import {useIntl} from 'react-intl'
import {
  // getAnchorsList,
  getPrelistName,
  getServiceT005,
  putServiceT005,
} from '../../core/prestation/request'
import {toast} from 'react-toastify'
import {useParams} from 'react-router-dom'
import {useSelector} from 'react-redux'
import {ListeServiceStatus, putT005} from '../../core/prestation/model'
import {useAuth} from '../../../../auth'
import * as lodash from 'lodash'
import {Button, Modal} from 'react-bootstrap'
import {useThemeMode} from '../../../../../../_metronic/partials/layout/theme-mode/ThemeModeProvider'
//import {optimize} from 'webpack'
import {CustomGoogleMapRoute} from '../../../../../common/components/Google/googleMap'
import {CenterHelp} from '../../../../../common/components/CenterHelp/CenterHelp'
import {HtmlRaw} from '../../../../../common/components/Parser/HtmlRaw'
import {RadioButton} from '../../../../../common/components/RadioButton/RadioButton'

const initialTBForm5Values = {
  WorkSiteAddress: '',
  WorkSiteLatitude: '',
  WorkSiteLongitude: '',
  SelectedAgency: '',
  LilleDistance: '',
  LilleTechnicalPrice: '',
  LilleTransportPrice: '',
  LilleStepNbr: null,
  LilleLatitude: '',
  LilleLongitude: '',
  NeuillyDistance: '',
  NeuillyTechnicalPrice: '',
  NeuillyTransportPrice: null,
  NeuillyStepNbr: '',
  NeuillyLatitude: '',
  NeuillyLongitude: '',
}

type ToggleButtonForm5Props = {
  isVisible4: boolean
  onDetectChange3?: (isThereChange: boolean) => void
  listeService?: any
  setListService?: any
  itemProps?: any
  setServiceData?: any
  onSavedForm?: (saved: boolean) => void
  loadListServiceStatus?: Function
  t005?: ListeServiceStatus
}

const ToggleButtonForm5: FC<ToggleButtonForm5Props> = ({
  isVisible4,
  onDetectChange3,
  listeService,
  setListService,
  itemProps,
  setServiceData,
  onSavedForm,
  //t005,
  loadListServiceStatus,
}) => {
  const intl = useIntl()
  const {pGuid} = useParams()
  const projectData = useSelector((state: any) => state.projectData)
  const Submitted = useSelector((state: any) => state?.projectStatus?.Submitted)
  const [serviceT005, setServiceT005] = useState<any>(null)
  const [serviceInitial, setServiceInitial] = useState<any>(null)
  const [selectedAgency, setSelectedAgency] = useState<any>(null)
  const [wayPoints, setWayPoint] = useState<Array<{lat: number | string; lng: number | string}>>([])
  const {setAuthMessage, logout} = useAuth()
  const [, setT1init] = useState<any>(null)
  const [showCancel, setShowCancel] = useState<boolean>(false)
  const [loading, setLoading] = useState<boolean>(true)
  const {mode} = useThemeMode()
  const [inputChange, setInputChange] = useState<any>(false)
  //const dispatch = useDispatch()
  const [dropdownData, setDropdownData] = useState<any[]>([])
  const formik = useFormik({
    initialValues: initialTBForm5Values,
    onSubmit: () => {},
  })

  useEffect(() => {
    if (Array.isArray(dropdownData)) {
      const item = dropdownData.find((data) => data?.Guid === selectedAgency?.Guid)
      if (item) {
        setSelectedAgency(item)
        if (item.Code === 'Lille') {
          setWayPoint([
            {lat: formik.values?.LilleLatitude || 0, lng: formik.values?.LilleLongitude || 0},
            {lat: formik.values?.WorkSiteLatitude || 0, lng: formik.values?.WorkSiteLongitude || 0},
          ])
        }
        if (item.Code === 'Neuilly') {
          setWayPoint([
            {lat: formik.values?.NeuillyLatitude || 0, lng: formik.values?.NeuillyLongitude || 0},
            {lat: formik.values?.WorkSiteLatitude || 0, lng: formik.values?.WorkSiteLongitude || 0},
          ])
        }
      }
    }
  }, [dropdownData, selectedAgency])
  const onRefreshListeService5 = () => {
    const services: any[] = [...listeService]
    const data = services.find((item) => item === itemProps)
    if (data) {
      const index = services.findIndex((item) => item === itemProps)
      if (index === -1) {
        //return
      }
      services.splice(index, 1, {...itemProps, Completed: true})
      setServiceData(itemProps)
      setListService(services)
    }
  }

  const loadServiceT005 = async () => {
    const response = await getServiceT005(
      pGuid || projectData?.tab1?.data?.Guid || '',
      (message: string) => {
        setAuthMessage(message)
        logout()
      },
      ({Message, MessageType, Toast, ToastType}) => {
        if (Message && MessageType === 'Success') {
          //
        } else if (Message && MessageType === 'Error') {
          //
        } else if (Toast && ToastType === 'Success') {
          toast(Toast, {type: 'success'})
        } else if (Toast && ToastType === 'Error') {
          toast(Toast, {type: 'error'})
        }
      }
    )
    if (response?.data && response?.data?.data) {
      console.log('dddd', response?.data?.data)
      setServiceT005(response?.data?.data)
      setServiceInitial(response?.data?.data)
      formik.setValues(response?.data?.data)
      setSelectedAgency({Guid: response?.data?.data?.SelectedAgency || ''})
      setT1init(response?.data?.data)
    }
    setLoading(false)
  }
  useEffect(() => {
    loadServiceT005()
  }, [])

  const handleClickT005 = async () => {
    try {
      if (serviceT005) {
        const dataToUpdate: putT005 = {
          ProjectGuid: pGuid || projectData?.tab1?.data?.Guid || '',
          SelectedAgency: selectedAgency?.Guid,
        }
        const response = await putServiceT005(dataToUpdate)
        if (response?.data?.Status?.Success) {
          if (onSavedForm) {
            onSavedForm(true)
          }
          if (loadListServiceStatus) {
            await loadListServiceStatus()
          }
        }
        await loadServiceT005()
        await onRefreshListeService5()
      } else {
      }
    } catch (error) {
      toast.error("Une erreur s'est produite lors de l'enregistrement des données")
    }
  }

  const isDisabled = useMemo(() => {
    return lodash.isEqual(formik.values, serviceInitial)
  }, [formik.values, serviceInitial])

  const onCancelReset = () => {
    setShowCancel(false)
  }
  const onConfirmCancel = async () => {
    if (pGuid) {
      await loadServiceT005()
      setShowCancel(false)
    } else {
      serviceT005({...initialTBForm5Values})
      setShowCancel(false)
    }
  }

  useEffect(() => {
    if (onDetectChange3) {
      onDetectChange3(isDisabled)
    }
  }, [isDisabled])

  const onAccessLost = (message: string) => {
    setAuthMessage(message)
    logout()
  }

  const loadPrelistName = async () => {
    const Guid: string = pGuid || projectData?.tab1?.data?.Guid
    setLoading(true)
    //let wsObjRes: any = null
    if (Guid) {
      const response = await getPrelistName(
        //{Guid: Guid},
        (message: string) => {
          setAuthMessage(message)
          logout()
        },
        ({Message, MessageType, Toast, ToastType}) => {
          if (Message && MessageType === 'Success') {
          } else if (Message && MessageType === 'Error') {
            //
          } else if (Toast && ToastType === 'Success') {
            toast(Toast, {type: 'success'})
          } else if (Toast && ToastType === 'Error') {
            toast(Toast, {type: 'error'})
          }
        }
      )
      if (response?.data?.Status?.FailureReason === 'Session expired') {
        onAccessLost(response?.data?.Status?.Message)
        return
      }
      //if(response?.data?.Status && re)
      if (response?.data?.data && Array.isArray(response?.data?.data)) {
        setDropdownData(response?.data?.data ?? [])
      }
    }
  }
  console.log('dropdown', dropdownData)

  useEffect(() => {
    loadPrelistName()
  }, [])

  // console.log('{serviceT005?.WorkSiteAddress}',serviceT005?.WorkSiteAddress);
  // console.log('way',wayPoints)
  return (
    <div>
      {isVisible4 && (
        <div className='d-flex flex-column'>
          <form>
            <div className='p-5 mt-8'>
              <div className='d-flex justify-content-between'>
                <div
                  style={{flex: 10}}
                  className='gap-1 justify-content-xl-between d-xl-flex flex-lg-column flex-lg-column flex-md-column flex-sm-column flex-column flex-xl-row flex-1'
                >
                  <div style={{flex: 0.5}}>
                    <div className='mb-10'>
                      <div className='fs-4 fw-bold text-gray-700 mb-5'>
                        {intl.formatMessage({id: 'SITE_ADDRESS'})}
                      </div>
                      <HtmlRaw text={serviceT005?.WorkSiteAddress} />
                    </div>

                    <div className='justify-content-xl-between justify-content-lg-between justify-content-md-between flex-sm-column flex-column flex-xl-row flex-lg-row flex-md-row d-xl-flex d-lg-flex d-md-flex'>
                      <div className='fs-5 text-gray-700 mt-3' style={{flex: 0.6}}>
                        {intl.formatMessage({id: 'SITE_ADRESS_LILLE'})}
                      </div>
                      <div className='gap-1 d-flex align-items-center' style={{flex: 0.4}}>
                        <input
                          readOnly
                          type='number'
                          className='form-control form-control-solid w-75 fs-7'
                          placeholder={intl.formatMessage({id: 'NUMBER'})}
                          {...formik.getFieldProps('LilleDistance')}
                        />
                      </div>
                    </div>

                    <div className='justify-content-xl-between justify-content-lg-between justify-content-md-between flex-sm-column flex-column flex-xl-row flex-lg-row flex-md-row d-xl-flex d-lg-flex d-md-flex my-5'>
                      <div className='fs-5 text-gray-700 mt-3' style={{flex: 0.6}}>
                        {intl.formatMessage({id: 'SITE_ADRESS_NEUILLY'})}
                      </div>
                      <div className='gap-1 d-flex align-items-center' style={{flex: 0.4}}>
                        <input
                          readOnly
                          type='number'
                          className='form-control form-control-solid w-75 fs-7'
                          placeholder={intl.formatMessage({id: 'NUMBER'})}
                          {...formik.getFieldProps('NeuillyDistance')}
                        />
                      </div>
                    </div>
                    <div className='d-flex justify-content-xl-between justify-content-lg-between justify-content-md-between flex-column '>
                      <div className='fs-5 text-gray-700 mt-3' style={{flex: 0.5}}>
                        {intl.formatMessage({id: 'CHOOSE_THE_AGENCY'})}
                      </div>
                      <div className='d-flex gap-13 my-3' style={{flex: 0.5}}>
                        {dropdownData.map((option, index) => (
                          <RadioButton
                            key={index}
                            classNameContainer='d-flex gap-3 align-items-center'
                            label={option.Name}
                            checked={selectedAgency?.Guid === option?.Guid}
                            classNameCheckedActive=''
                            classNameCheckedInactive=''
                            classNameDefaultLabel=''
                            handleClick={() => {
                              setSelectedAgency(option)
                              formik.setFieldValue('SelectedAgency', option?.Guid ?? '')
                              /*setWayPoint([
                              {lat :'',lng: 4}
                            ])*/
                              console.log('option', option)
                              if (option.Code === 'Lille') {
                                setWayPoint([
                                  {
                                    lat: formik.values?.LilleLatitude || 0,
                                    lng: formik.values?.LilleLongitude || 0,
                                  },
                                  {
                                    lat: formik.values?.WorkSiteLatitude || 0,
                                    lng: formik.values?.WorkSiteLongitude || 0,
                                  },
                                ])
                              }
                              if (option.Code === 'Neuilly') {
                                setWayPoint([
                                  {
                                    lat: formik.values?.NeuillyLatitude || 0,
                                    lng: formik.values?.NeuillyLongitude || 0,
                                  },
                                  {
                                    lat: formik.values?.WorkSiteLatitude || 0,
                                    lng: formik.values?.WorkSiteLongitude || 0,
                                  },
                                ])
                              }
                            }}
                          />
                          /*  <div key={index} className='d-flex gap-3 align-items-center'>
                            <div
                              className='bg-light'
                              onClick={async () => {
                                setSelectedAgency(option)
                                formik.setFieldValue('SelectedAgency', option?.Guid ?? '')
                              }}
                              style={{
                                ...{
                                  border: '1px solid gray',
                                  borderRadius: 100,
                                  width: 20,
                                  height: 20,
                                },
                                ...(selectedAgency?.Guid === option?.Guid
                                  ? {
                                      border: '6px solid #e74c3c',
                                    }
                                  : {}),
                              }}
                            ></div>
                            <label>{option.Name}</label>
                          </div> */
                        ))}
                      </div>
                    </div>
                  </div>

                  <div style={{flex: 0.5}} className='w-100'>
                    {formik.values?.SelectedAgency &&
                      formik.values?.SelectedAgency !== '00000000-0000-0000-0000-000000000000' &&
                      wayPoints.length > 0 && (
                        <CustomGoogleMapRoute
                          marker={wayPoints}
                          /*marker={[
                            {lat: formik.values?.WorkSiteLatitude || 0, lng: formik.values?.WorkSiteLongitude || 0},
                            {lat: formik.values?.LilleLatitude || 0, lng: formik.values?.LilleLongitude || 0},
                            {
                              lat: formik.values?.NeuillyLatitude || 0, //? Number((Number(formik.values?.NeuillyLatitude) || 0)?.toFixed(1)) : 0,
                              lng: formik.values?.NeuillyLongitude || 0// ? Number((Number(formik.values?.NeuillyLongitude) || 0)?.toFixed(1)) : 0
                            }
                            //{lat: formik.values?.WorkSiteLatitude || 0, lng:formik.values?.WorkSiteLongitude || 0}
                          ]}*/
                          /* WorkSiteLatitude={
                            selectedAgency?.Code == 'Lille'
                              ? formik.values?.LilleLatitude
                              : formik.values?.NeuillyLatitude
                          }
                          WorkSiteLongitude={
                            selectedAgency?.Code == 'Lille'
                              ? formik.values?.LilleLongitude
                              : formik.values?.NeuillyLongitude
                          }*/
                        />
                      )}
                  </div>
                </div>

                <div className='justify-content-end'>{/*<CenterHelp />*/}</div>
              </div>
              {/*
              <div className='d-flex justify-content-between' style={{marginTop: '50px'}}>
                <div
                  style={{flex: 10}}
                  className='align-items-center justify-content-xl-between justify-content-lg-between justify-content-md-between d-xl-flex d-lg-flex d-md-flex flex-sm-column flex-column flex-xl-row flex-lg-row  flex-md-row flex-1'
                >
                  <div className='fs-5 text-gray-700' style={{flex: 0.5}}>
                    {intl.formatMessage({id: 'MANDATORY_PRE_INSPECTION_VISIT'})}{' '}
                  </div>
                  <b className='mx-3' style={{flex: 0.5}}>
                    {selectedAgency?.Code === 'Lille'
                      ? formik.values.LilleTechnicalPrice
                      : selectedAgency?.Code === 'Neuilly'
                      ? formik.values.NeuillyTechnicalPrice
                      : 'Pas de frais associés'}
                  </b>
                </div>
                <div className='justify-content-end'>
                  <CenterHelp />
                </div>
              </div>

              <div className='d-flex justify-content-between my-5'>
                <div
                  style={{flex: 10}}
                  className='align-items-center justify-content-xl-between justify-content-lg-between justify-content-md-between d-xl-flex d-lg-flex d-md-flex flex-sm-column flex-column flex-xl-row flex-lg-row  flex-md-row flex-1'
                 >
                  <span className='fs-5 text-gray-700' style={{flex: 0.5}}>
                    {intl.formatMessage({id: 'PACKAGE_KM'})}
                  </span>
                  <div style={{flex: 0.5}} className='d-flex gap-3 align-items-center'>
                    <input
                      type='text'
                      readOnly
                      {...formik.getFieldProps(
                        selectedAgency?.Code === 'Lille'
                          ? 'LilleTransportPrice'
                          : 'NeuillyTechnicalPrice'
                      )}
                      className='form-control form-control-solid w-50 fs-7'
                    />
                    <i className='fa-solid fa-euro-sign fs-1' style={{color: '#0c0d0d'}}></i>
                  </div>
                </div>
                <div className='justify-content-end'>
                  <CenterHelp />
                </div>
              </div>

              <div className='d-flex justify-content-between my-5'>
                <div
                  style={{flex: 10}}
                  className='align-items-center justify-content-xl-between justify-content-lg-between justify-content-md-between d-xl-flex d-lg-flex d-md-flex flex-sm-column flex-column flex-xl-row flex-lg-row  flex-md-row flex-1'
                >
                  <label className='fs-5 text-gray-700 mt-3' style={{flex: 0.5}}>
                    {intl.formatMessage({id: 'STOPOVER_PACKAGE'})}
                  </label>
                  <div style={{flex: 0.5}} className='d-flex gap-3 align-items-center'>
                    <input
                      readOnly
                      type='text'
                      className='form-control form-control-solid w-50 fs-7'
                      {...formik.getFieldProps(
                        selectedAgency?.Code === 'Lille' ? 'LilleStepNbr' : 'NeuillyStepNbr'
                      )}
                    />
                    <label>{intl.formatMessage({id: 'NIGHT'})}</label>
                  </div>
                </div>
                <div className='justify-content-end'>
                  <CenterHelp />
                </div>
              </div>
                      */}

              {!Submitted && (
                <div className='d-flex gap-5 justify-content-end my-5'>
                  <span style={{cursor: isDisabled ? 'not-allowed' : 'pointer'}}>
                    <Button
                      className='btn btn-dark'
                      disabled={isDisabled}
                      onClick={() => {
                        if (!lodash.isEqual(formik.values, serviceInitial)) {
                          setShowCancel(true)
                        } else {
                          if (inputChange) {
                            setServiceT005({...serviceInitial})
                            formik.setValues(serviceInitial)
                            setInputChange(false)
                          }
                        }
                      }}
                    >
                      {intl.formatMessage({id: 'RESET'})}
                      <i className='fa-solid fa-eraser fs-4 ms-2'></i>
                    </Button>
                  </span>
                  <span style={{cursor: isDisabled ? 'not-allowed' : 'pointer'}}>
                    <Button
                      type='button'
                      className='btn btn-danger'
                      onClick={handleClickT005}
                      disabled={isDisabled}
                    >
                      {intl.formatMessage({id: 'SAVE'})}
                      <i className='fa-regular fa-floppy-disk fs-4 ms-2'></i>
                    </Button>
                  </span>
                </div>
              )}
            </div>
          </form>
          <Modal show={showCancel} centered>
            <div className='text-center p-5 w-100' data-bs-theme={mode}>
              <div
                className={'w-100 rounded ' + (mode === 'dark' ? ' bg-none ' : ' bg-white ')}
                data-bs-theme={mode}
              >
                <div className='d-flex align-items-center justify-content-between'>
                  <div className='fw-bolder text-gray-700 py-3'>
                    {intl.formatMessage({id: 'INFORMATION'})}
                  </div>
                  <div className='p-1 cursor-pointer' onClick={onCancelReset}>
                    <i className='fa fa-close text-danger'></i>
                  </div>
                </div>
                <div className={'text-start py-3'}>
                  <div>{intl.formatMessage({id: 'RESET_CONFIRM_MESSAGE'})}</div>
                </div>
                <div className='d-flex align-items-center justify-content-evenly'>
                  <button className={'btn btn-secondary'} onClick={onCancelReset}>
                    {intl.formatMessage({id: 'NO'})}
                  </button>
                  {!loading && (
                    <button className={'btn btn-primary'} onClick={onConfirmCancel}>
                      {intl.formatMessage({id: 'YES'})}
                    </button>
                  )}
                  {loading && (
                    <button className={'btn btn-primary'} onClick={() => {}}>
                      {'...'}
                    </button>
                  )}
                </div>
              </div>
            </div>
          </Modal>
        </div>
      )}
    </div>
  )
}

export default ToggleButtonForm5
